import React, { Component } from "react";

import { inject, observer } from "mobx-react";
import { Link, withRouter} from "react-router-dom";
import "./BookingDetails.css";
import { Grid, Typography, Button, Menu, Snackbar, IconButton, Tooltip,MenuItem} from "@material-ui/core";
import ResponsiveTable from "../table/ResponsiveTable";
import BookingStatusBadge from "./BookingStatusBadge";
import moment from "moment";
import ConfirmationModal from "../modal/ConfirmationModal";
import CloseIcon from "@material-ui/icons/Close";
import ClearIcon from "@material-ui/icons/Clear";
import { ProfileType, BookingType, BookingStatusType,RosterDividendType, LineupStatusType } from "../../types/enum";
import CheckCircle from "@material-ui/icons/CheckCircle";
import DirectionsIcon from "@material-ui/icons/Directions";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import EditIcon from "@material-ui/icons/Edit";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import PrintIcon from "@material-ui/icons/Print";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import bookingCalculationHelper from "../../helper/bookingCalculationHelper"


import currencyHelper from '../../helper/currency';
import { Fragment } from "react";


//Booking Status cancelled only has canelled status
const BOOKING_STATUS = [
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled By Act",
    "Cancelled By Act",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled",
    "Cancelled"
];

@inject("profileStore", "bookingRequestStore", "templateStore", "reportStore")
@withRouter
@observer
class BookingCancelled extends Component {
    state = {
        columns: [],
        actionAnchor: [],
        duplicateModalState: true,
        duplicateModalState: null,
        openDuplicateSnackbar: false,
        duplicateBooking: undefined,
        page: 1
    };

    rows = [];

    componentDidMount() {
        const { cancelled } = this.props.bookingRequestStore;
        if (this.props.profileType === "agent") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date/Time", width: "10%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "venue", label: "Venue", width: "12%" },
                    { key: "actName", label: "Act Name", width: "12%" },
                    { key: "status", label: "Status", width: "8%", style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
                    { key: "gigFee", label: <Tooltip title="Venue/Client Fee"><span>V/C Fee</span></Tooltip>, sortable: true, width: "7%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "agentFee", label: <Tooltip title="Agent Fee"><span>Agent Fee</span></Tooltip>, sortable: true, width: "7%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "actFee", label: <Tooltip title="Performance Fee"><span>Perf. Fee</span></Tooltip>, sortable: true, width: "7%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "superFee", label: <Tooltip title="Superannuation Fee"><span>Super Fee</span></Tooltip>, sortable: true, width: "7%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "feePaidToAct", label: <Tooltip title="Invoice Amount"><span>Inv. Amt</span></Tooltip>, sortable: true, width: "7%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "action", label: "Actions", width: "8%" }
                ]
            });
        } else if (this.props.profileType === "staff") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date", width: "15%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "status", label: "Status", width: "15%" },
                    { key: "actName", label: "Act Name", width: "15%" },
                    { key: "venue", label: "Venue", width: "15%" },
                    { key: "gigFee", label: "Gig Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } }, 
                    { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                    { key: "actFee", label: "Performance Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } }, 
                    // { key: "acknowledge", label: "", width: "10%" },
                    { key: "bookingCreator", label: "Booking Creator", width: "10%" },
                    { key: "action", label: "", width: "10%" }
                ]
            });
        } else if (this.props.profileType === "musician") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date/Time", width: "10%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "venue", label: "Venue", width: "12%" },
                    { key: "actName", label: "Act Name", width: "12%" },
                    { key: "status", label: "Status", width: "8%", style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
                    { key: "gigFee", label: <Tooltip title="Venue/Client Fee"><span>V/C Fee</span></Tooltip>, sortable: true, isNumber: true, width: "7%", align: 'left', style: { flexDirection: 'row' } },
                    { key: "agentCommissionAmount", label: "Agent Fee", sortable: true, isNumber: true, width: "7%", align: 'left', style: { flexDirection: 'row' } },
                    { key: "myFee", label: <Tooltip title="Performance Fee"><span>Perf. Fee</span></Tooltip>, width: "7%", isNumber:true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "superFee", label: "Super Fee", sortable: true, width: "7%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "feePaidToAct", label: <Tooltip title="Invoice Amount"><span>Inv. Amt</span></Tooltip>, sortable: true, width: "7%", isNumber: true, align: 'left', style: { flexDirection: 'row' } },
                    { key: "action", label: "Actions", width: "8%" }
                ]
            });
        } else if (this.props.profileType === "PrivateHire") {
            this.setState({
                ...this.state,
                columns: [
                    { key: "date", label: "Date", width: "15%", sortable: true, isDate: true, style: {whiteSpace: 'nowrap'}, addComp: true },
                    { key: "status", label: "Status", width: "15%" },
                    { key: "actName", label: "Act Name", width: "15%" },
                    { key: "venue", label: "Venue", width: "15%" },
                    { key: "actFee", label: "Gig Fee", sortable: true, isNumber: true, width: "10%", align: 'left', style: { flexDirection: 'row' } },
                    // { key: "acknowledge", label: "", width: "10%" },
                    { key: "bookingCreator", label: "Booking Creator", width: "10%" },
                    { key: "action", label: "", width: "10%" }
                ]
            });
        }
    }

    setActionAnchor = (element, bookingId) => {
        var tempAnchor = [];
        tempAnchor[bookingId] = element;
        this.setState({ ...this.state, actionAnchor: tempAnchor });
    };

    loadCancelledGigs = (page) => {
        const {currentProfile} = this.props.profileStore
        this.props.bookingRequestStore.showLoadingState()
        this.props.bookingRequestStore.getCancelledGigs(currentProfile?.id, page).then(() => {
            this.props.bookingRequestStore.hideLoadingState();
        })
    }

    handleShowMore = e => {
        this.props.bookingRequestStore.showLoadingState();
        var page = parseInt(this.props.bookingRequestStore.cancelledPage) + 1;
        this.loadCancelledGigs(page)
    };
    unsetActionAchnor = bookingId => {
        this.setState({ ...this.state, actionAnchor: [] });
    };
    
    handleOpenDuplicateBookingModal = booking => this.setState({ duplicateModalState: true, duplicateBooking: booking, actionAnchor: [] });
    handleCloseDuplicateBookingModal = () => {
        this.setState({
            ...this.state,
            duplicateModalState: false,
            duplicateBooking: null
        });
    };
    handleDupicateRequest = () => {
        const { duplicateBooking } = this.state;
        const bookingRequestId = duplicateBooking?.bookingRequests?.filter(x => !x.deleted)[0]?.id || 0;

        this.props.bookingRequestStore.getDetailBookingCalendar(duplicateBooking.id, bookingRequestId)
            .then(() => {
                const freshBooking = this.props.bookingRequestStore.bookingDetail;
                this.props.bookingRequestStore.setDuplicateBooking(freshBooking);

                this.props.history.push(
                    `/booking/new?actId=${freshBooking?.actId ? freshBooking?.actId : "undefined"}&venueId=${freshBooking?.venueId ? freshBooking?.venueId : "undefined"}&duplicateBooking=${true}&dateStart=${freshBooking?.dateStart ? moment(freshBooking?.dateStart, "DD-MM-YYYY").add(1, "days").format("DD-MM-YYYY") : moment(new Date()).format("DD-MM-YYYY")}`,
                    { from: 'fromBookingStation' }
                );
                this.handleCloseDuplicateBookingModal();
                this.setState({ openDuplicateSnackbar: true });
            });
    };

    handleSnackbarEditClose = (event, reason) => {
        this.setState({ openDuplicateSnackbar: false });
    };

    getBookingStatus = (booking) => {
        if (moment(booking.dateStart).endOf("day") < moment().startOf("day")) {
            if (
                booking.status === BookingStatusType.New.ordinal ||
                booking.status === BookingStatusType.Hold.ordinal ||
                booking.status === BookingStatusType.Cancelled.ordinal ||
                booking.status === BookingStatusType.Draft.ordinal
            ) {
                return "Cancelled";
            } else {
                return BOOKING_STATUS[booking ? booking.status : 0];
            }
        } else {
            return BOOKING_STATUS[booking ? booking.status : 0];
        }
    };

    renderMobileGigCard = (row, index) => {
        return (
            <div key={index} className="mobile-gig-card" style={row.style}>
                <div className="mobile-gig-card-header">
                    {row.date?.newFormat}
                    <div className="mobile-gig-card-venue">
                        {row.venue}
                    </div>
                </div>
                <div className="mobile-gig-card-fees">
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Venue/Client Fee</span>
                        <span className="mobile-gig-fee-value">{row.gigFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Agent Fee</span>
                        <span className="mobile-gig-fee-value">{row.agentCommissionAmount}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Performance Fee</span>
                        <span className="mobile-gig-fee-value">{row.myFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Invoice Amount</span>
                        <span className="mobile-gig-fee-value">{row.feePaidToAct}</span>
                    </div>
                </div>
                <div className="mobile-gig-card-footer">
                    <div className="mobile-gig-card-act">
                        <div className="mobile-gig-card-status">{row.status}</div>
                        {row.actName}
                    </div>
                    <div className="mobile-gig-card-actions">
                        {row.action}
                    </div>
                </div>
            </div>
        );
    }

    renderAgentMobileGigCard = (row, index) => {
        return (
            <div key={index} className="mobile-gig-card" style={row.style}>
                <div className="mobile-gig-card-header">
                    {row.date?.newFormat}
                    <div className="mobile-gig-card-venue">
                        {row.venue}
                    </div>
                </div>
                <div className="mobile-gig-card-act" style={{ padding: '12px 16px', borderBottom: '1px solid #eee' }}>
                    <div className="mobile-gig-card-status">{row.status}</div>
                    {row.actName}
                </div>
                <div className="mobile-gig-card-fees">
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Venue/Client Fee</span>
                        <span className="mobile-gig-fee-value">{row.gigFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Agent Fee</span>
                        <span className="mobile-gig-fee-value">{row.agentFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Performance Fee</span>
                        <span className="mobile-gig-fee-value">{row.actFee}</span>
                    </div>
                    <div className="mobile-gig-fee-item">
                        <span className="mobile-gig-fee-label">Invoice Amount</span>
                        <span className="mobile-gig-fee-value">{row.feePaidToAct}</span>
                    </div>
                </div>
                <div className="mobile-gig-card-footer">
                    <div className="mobile-gig-card-actions">
                        {row.action}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let { cancelled } = this.props.bookingRequestStore;
        let { currentProfile } = this.props.profileStore;
        const { profileType } = this.props;
        const { venueId } = this.props.reportStore;
        if (venueId) {
            cancelled = cancelled.filter(x => x.venueId === venueId);
            this.props.bookingRequestStore.setBookingsCount("cancelled", cancelled);
        }

        return (
            <Fragment>
                <Grid container spacing={8}>
                    <Grid item xs={12} lg={12}>
                            <Typography variant="headline" component="h3" gutterBottom style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                Cancelled Gigs
                                <Tooltip title={profileType === "musician" ? "This is the list of your cancelled gigs." : "This is the list of cancelled gigs."}>
                                    <HelpOutlineIcon style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} />
                                </Tooltip>
                            </Typography>
                    </Grid>
                    <Grid item xs={12} lg={12} className="booking-table-wrapper">
                        <ResponsiveTable
                            sortable={true}
                            mobileSecondaryField="venue"
                            columns={this.state.columns}
                            mobileCardRenderer={profileType === "musician" ? this.renderMobileGigCard : profileType === "agent" ? this.renderAgentMobileGigCard : undefined}
                            rows={cancelled.map(booking => {
                                var row = {};
                                let date = new Date(booking.dateStart);
                                // row.date = date.getDate()+" "+this.props.templateStore.getMonth(date.getMonth())+" "+date.getFullYear();
                                var formattedDate = moment(booking.dateStart).format("YYYY-MM-DD")
                                
                                
                                let time = booking.timeStart.length < 8 ? `0${booking.timeStart}` : booking.timeStart;
                                let endTime = booking.timeEnd.length < 8 ? `0${booking.timeEnd}` : booking.timeEnd;
                                var finalDate= moment(formattedDate + ' ' + time)
                                row.date = {newFormat: 
                                    (
                                        <div className="gig-date-box">
                                            <div className="day-name">{booking.dateStart.format("ddd")}</div>
                                            <div className="date-number">{booking.dateStart.format("DD")}</div>
                                            <div className="month">{booking.dateStart.format("MMM YYYY")}</div>
                                            <div className="time-range">{`${moment(time, 'HH:mm:ss').format('h:mm A')} - ${moment(endTime, 'HH:mm:ss').format('h:mm A')}`}</div>
                                        </div>
                                    ), value: finalDate};
                                row.venue = (
                                    <div>
                                        <span style={{fontWeight: 600}}>{booking.venue ? booking.venue.profileName : booking.venueName}</span>
                                        <br />
                                        <small style={{color: '#888'}}>{booking.venueAddress}</small>
                                    </div>
                                );
                                // row.address = booking.venueAddress;
                                row.agentName = booking.agentName;
                                var collectedFee = bookingCalculationHelper.calculatedBookingFee(booking, currentProfile)
                               
                                row.time = moment(booking.timeStart, "HH:mm:ss").format(this.props.templateStore.getFormat12Hour(booking.timeStart));
                                row.gigFee = booking.createdBy?.type === ProfileType.Agent.ordinal && (booking.agentOwner?.hideVenueFees && currentProfile?.type === ProfileType.Musician.ordinal) ? <i className={"icon-eye-blocked"} /> :
                                (booking.viewOnly)  || (currentProfile && currentProfile.type === ProfileType.Staff.ordinal && !currentProfile.allowInvoices)
                                    ? <i class="far fa-eye-slash"></i>
                                    : `${currentProfile?.currencySymbol + ((profileType === "agent" || profileType === "staff") && booking.isApproved
                                        ? currencyHelper.formatMoney((Number(collectedFee.gigFee) + Number(booking.extraGigFee)).toFixed(2), 2) 
                                        : currencyHelper.formatMoney(Number(collectedFee.gigFee).toFixed(2), 2))}`;
                                row.agentFee = collectedFee.agentFee
                                const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal && booking.createdById === currentProfile?.id && !booking.act?.actName;

                                row.actName = profileType === "musician" ? (
                                    <div>
                                        <div className="gig-act-name">
                                            <a target={"_blank"} href={`/profile/${isEntertainerBookings ? currentProfile?.id : booking?.act?.id}`}>
                                                {isEntertainerBookings ? `${currentProfile?.firstName} ${currentProfile?.lastName}` : booking.act ? booking?.act?.actName : ""}
                                            </a>
                                        </div>
                                        {booking.act?.contactName && <div className="gig-act-contact">{booking.act?.contactName}</div>}
                                        {booking.act?.contactPhone && <div className="gig-act-contact">{booking.act?.contactPhone}</div>}
                                    </div>
                                ) : (
                                    <div>
                                        <Link target={"_blank"} to={`/profile/${isEntertainerBookings ? currentProfile?.id : booking?.act?.id}`}>{isEntertainerBookings ? `${currentProfile?.firstName} ${currentProfile?.lastName}` : booking.act ? booking?.act?.actName : ""}</Link>
                                        <br />
                                        {booking.act && <small>Contact: {booking?.act?.contactName}</small>}<br />
                                        {booking.act && <small>Phone: {booking?.act?.contactPhone ? booking?.act?.contactPhone  : "-"}</small>}
                                    </div>
                                );
                                row.actFee = booking.createdBy?.type === ProfileType.Agent.ordinal && (currentProfile?.type === ProfileType.Staff.ordinal && booking.agentOwner?.hideVenueAgencyFees) ? <i className={"icon-eye-blocked"} /> : currentProfile?.currencySymbol + parseFloat(booking.actFee);
                               
                              
                                row.myFee = this.props.profileType === 'musician' && currentProfile?.currencySymbol + currencyHelper.formatMoney(collectedFee.myFee, 2);
                                row.agentCommissionAmount = collectedFee.agentCommissionAmount                                
                                row.superFee = collectedFee.superFee
                                row.feePaidToAct = collectedFee.feePaidToAct
                                                                      
                                row.bookingCreator = booking?.createdBy ? (booking?.createdBy?.firstName + " " +booking?.createdBy?.lastName) : ""
                                row.isSendBookingDetails = booking.isSendBookingDetails ? <div style={{textAlign:"center", width:"100%"}}><CheckCircle style={{ texAlign:"center",color: "green"}} /></div>  : null;
                                
                                const handleGetDirections = () => {
                                    const address = encodeURIComponent(booking.venueAddress || '');
                                    window.open(`https://www.google.com/maps/dir/?api=1&destination=${address}`, '_blank');
                                };
                                
                                const handleViewDetails = () => {
                                    let redirectUrl =
                                        booking.type === BookingType.Adhoc.ordinal
                                        ? `/privateBooking/${booking.id}/edit`
                                        : currentProfile?.type === ProfileType.Musician.ordinal
                                            ? `/musician/booking/${booking.id}/details`
                                            : currentProfile?.type === ProfileType.Agent.ordinal
                                                ? `/booking/${booking.id}/edit`
                                                : currentProfile?.type === ProfileType.Staff.ordinal
                                                    ? `/booking/${booking.id}/edit`
                                                    : "";
                                    process.env.REACT_APP_DISABLE_BILLING_MOBILE !== "true" ? window.open(redirectUrl, '_blank'):                         
                                    this.props.history.push(redirectUrl, { from: 'fromMyGigs' });
                                };
                                
                                row.action = profileType === "musician" ? (
                                    <div className="gig-actions-dropdown">
                                        <Button 
                                            className="gig-actions-dropdown-btn"
                                            onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                        >
                                            Actions <ArrowDropDownIcon />
                                        </Button>
                                        <Menu
                                            open={this.state.actionAnchor[booking.id] != null}
                                            onClose={() => this.unsetActionAchnor(booking.id)}
                                            anchorEl={this.state.actionAnchor[booking.id]}
                                        >
                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); handleViewDetails(); }}>
                                                <VisibilityIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                View Details
                                            </MenuItem>
                                            <MenuItem 
                                                onClick={() => { this.unsetActionAchnor(booking.id); handleGetDirections(); }}
                                                disabled={!booking.venueAddress}
                                            >
                                                <DirectionsIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                Get Directions
                                            </MenuItem>
                                        </Menu>
                                    </div>
                                ) : profileType === "agent" ? (
                                    <div className="gig-actions-dropdown">
                                        <Button 
                                            className="gig-actions-dropdown-btn"
                                            onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                        >
                                            Actions <ArrowDropDownIcon />
                                        </Button>
                                        <Menu
                                            open={this.state.actionAnchor[booking.id] != null}
                                            onClose={() => this.unsetActionAchnor(booking.id)}
                                            anchorEl={this.state.actionAnchor[booking.id]}
                                        >
                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); handleViewDetails(); }}>
                                                <EditIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                View / Edit
                                            </MenuItem>
                                            <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.handleOpenDuplicateBookingModal(booking); }}>
                                                <FileCopyIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                Duplicate Booking
                                            </MenuItem>
                                            {booking.createdById === currentProfile?.id && (
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.props.history.push(`/booking/${booking.id}/sendBookingEmail`); }}>
                                                    <span style={{ marginRight: 10, color: '#888', fontSize: 18 }}>✉</span>
                                                    Send Booking Details via Email
                                                </MenuItem>
                                            )}
                                            {booking.createdById === currentProfile?.id && (
                                                <MenuItem onClick={() => { this.unsetActionAchnor(booking.id); this.props.history.push(`/booking/printBookingDetails/${booking.id}`); }}>
                                                    <PrintIcon style={{ marginRight: 10, color: '#888', fontSize: 18 }} />
                                                    Print Booking Details
                                                </MenuItem>
                                            )}
                                        </Menu>
                                    </div>
                                ) : (
                                    <div className="gig-actions">
                                        <Tooltip title={booking.venueAddress ? "Get Directions" : "No address available"}>
                                            <span>
                                                <IconButton 
                                                    className="gig-action-btn" 
                                                    onClick={handleGetDirections}
                                                    disabled={!booking.venueAddress}
                                                    style={!booking.venueAddress ? { opacity: 0.5, pointerEvents: 'none' } : {}}
                                                >
                                                    <DirectionsIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                        <Tooltip title="View Details">
                                            <IconButton 
                                                className="gig-action-btn" 
                                                onClick={handleViewDetails}
                                            >
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Tooltip>
                                        {(booking.createdById === currentProfile?.id || booking.isBookingVenueManagemenet) && (
                                            <Fragment>
                                                <Tooltip title="More Actions">
                                                    <IconButton 
                                                        className="gig-action-btn" 
                                                        onClick={e => this.setActionAnchor(e.currentTarget, booking.id)}
                                                    >
                                                        <span style={{fontSize: '18px', fontWeight: 'bold'}}>...</span>
                                                    </IconButton>
                                                </Tooltip>
                                                {booking.id && (
                                                    <Menu
                                                        open={this.state.actionAnchor[booking.id] != null}
                                                        onClose={() => this.unsetActionAchnor(booking.id)}
                                                        anchorEl={this.state.actionAnchor[booking.id]}
                                                    >
                                                        <MenuItem onClick={() => this.handleOpenDuplicateBookingModal(booking)}>Duplicate Booking</MenuItem>
                                                    </Menu>
                                                )}
                                            </Fragment>
                                        )}
                                    </div>
                                );
                                let entertainerBookingCancelled = isEntertainerBookings && booking.cancelledBy?.type === ProfileType.Musician.ordinal;
                                row.status = (
                                    <BookingStatusBadge 
                                    cancelledBy={ (booking && booking.cancelledBy ? booking.cancelledBy.type : 0)}
                                    status={this.getBookingStatus(booking)} />
                                );
                                return row;
                            })}
                        />
                    </Grid>

                    <Grid item style={{marginTop: 25}} xs={12} key="more" alignContent="center" alignItems="center" justify="center">
                        <Grid container direction="row" justify="center" alignItems="center">
                            {this.props.bookingRequestStore.showMoreCancelled ? (
                                <Button variant="outlined" size="large" color="primary" onClick={this.handleShowMore}>
                                    Show More
                                </Button>
                            ) : null}
                        </Grid>
                    </Grid>
                </Grid>

                <ConfirmationModal
                    open={this.state.duplicateModalState}
                    message={`Are you sure you want to duplicate this booking - ${this.state.duplicateBooking?.title}?`}
                    closeHandler={this.handleCloseDuplicateBookingModal}
                    confirmationHandler={this.handleDupicateRequest}
                    declineHandler={this.handleCloseDuplicateBookingModal}
                    confirmationLabel="Duplicate"
                />
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right"
                    }}
                    open={this.state.openDuplicateSnackbar}
                    autoHideDuration={4000}
                    onClose={this.handleSnackbarEditClose}
                    SnackbarContentProps={{
                        "aria-describedby": "message-id"
                    }}
                    message={<span id="message-id">Booking {this.state.duplicateBooking?.title} duplicated</span>}
                    action={
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleSnackbarEditClose}>
                            <CloseIcon />
                        </IconButton>
                    }
                />
            </Fragment>
        );
    }
}

export default BookingCancelled;
